var Lights = (function(){

    function Lights(){
        THREE.Object3D.call(this);

        var loader = new THREE.JSONLoader();
        loader.load('assets/models/suzanne/suzanneHi.js', this.onSuzanneLoaded.bind(this));

        var path = "assets/textures/skybox/";
        var format = '.jpg';
        var urls = [
            path + 'px' + format, path + 'nx' + format,
            path + 'py' + format, path + 'ny' + format,
            path + 'pz' + format, path + 'nz' + format
        ];
        var reflectionCube = THREE.ImageUtils.loadTextureCube(urls);
        reflectionCube.format = THREE.RGBFormat;

        this.material = new THREE.MeshPhongMaterial({color: 0x555555, metal: true, combine: THREE.MixOperation, reflectivity: 0, transparent: true, envMap: reflectionCube, shading: THREE.SmoothShading});
    }

    Lights.prototype = new THREE.Object3D;
    Lights.prototype.constructor = Lights;

    Lights.prototype.onSuzanneLoaded = function(geometry) {
        this.mesh = new THREE.Mesh(geometry, this.material);
        this.add(this.mesh);
        this.mesh.scale.multiplyScalar(0.75);
        this.mesh.rotation.y = Math.PI;
    };

    return Lights;
})();